import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=419f04ab&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=419f04ab&prod&lang=less"
import style1 from "./Main.vue?vue&type=style&index=1&id=419f04ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419f04ab",
  null
  
)

export default component.exports